import { createSlice } from "@reduxjs/toolkit";

const currentLocationSlice = createSlice({
    name: 'currentLocation',
    initialState:{
        latitude: "10.16841",
        longitude: "107.16841"
    },
    reducers:{
        updateCurrentLocation(state, action) {
            state.latitude = (action.payload.lat);
            state.longitude = (action.payload.lng);
          },
    },
    extraReducers:{}
})
export const { updateCurrentLocation } = currentLocationSlice.actions 

export default currentLocationSlice.reducer;